/**
 * VipManagementRepository
 * VIP 관리 API 호출 레이어
 */
import { API_BASE_URL } from '../../../config/api';
import type { VipMember, TierConfig, VipStatistics } from '../models/VipManagement';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export class VipManagementRepository {
  /**
   * VIP 회원 목록 조회
   */
  async getMembers(params: {
    page: number;
    limit: number;
    sort_by: string;
    sort_order: string;
    tier_level?: string;
    search?: string;
  }): Promise<VipMember[]> {
    const queryParams = new URLSearchParams({
      page: params.page.toString(),
      limit: params.limit.toString(),
      sort_by: params.sort_by,
      sort_order: params.sort_order,
      ...(params.tier_level && { tier_level: params.tier_level }),
      ...(params.search && { search: params.search }),
    });

    const response = await fetch(`${API_BASE_URL}/api/v1/vip/members?${queryParams}`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }

  /**
   * 등급 설정 목록 조회
   */
  async getTierConfigs(): Promise<TierConfig[]> {
    const response = await fetch(`${API_BASE_URL}/api/v1/vip/tiers`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.tiers;
  }

  /**
   * VIP 통계 조회
   */
  async getStatistics(): Promise<VipStatistics> {
    const response = await fetch(`${API_BASE_URL}/api/v1/vip/statistics`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }
}

export const vipManagementRepository = new VipManagementRepository();
